"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const map_1 = __importDefault(require("lodash/map"));
/**
 * Returns formatted image array
 * @param images
 */
const getImages = (images) => {
    return (0, map_1.default)(images, (image) => {
        return {
            id: (0, get_1.default)(image, 'id'),
            url: (0, get_1.default)(image, 'url', ''),
        };
    });
};
exports.default = getImages;
